import React, { useState } from "react";
import {
Box,
Card,
Typography,
TextField,
Button,
Checkbox,
FormControlLabel,
Snackbar,
Alert,
CircularProgress,
InputAdornment,
IconButton
} from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

import { useLocation, useNavigate } from "react-router-dom";
import { adminFetch } from "../services/adminFetch";
import { adminPageSx } from "../utils/adminResponsive";

export default function DeleteUser(){

const { state } = useLocation();
const navigate = useNavigate();

const user = state?.user;

const [password,setPassword] = useState("");
const [notify,setNotify] = useState(true);
const [confirmed,setConfirmed] = useState(false);
const [loading,setLoading] = useState(false);
const [showPassword,setShowPassword] = useState(false);


const [snackbar,setSnackbar] = useState({
open:false,
message:"",
severity:"success"
});

const showSnackbar = (message,severity="success")=>{
setSnackbar({open:true,message,severity});
};

const handleCloseSnackbar = ()=>{
setSnackbar({...snackbar,open:false});
};




const handleDelete = async () => {

if(!password){
showSnackbar("Admin password required","error");
return;
}

if(!confirmed){
showSnackbar("Confirm that financial and lottery history will be preserved while access is closed","error");
return;
}

setLoading(true);

try{

const data = await adminFetch("/api/user/delete-user",{
   method:"DELETE", 
   body:JSON.stringify({
   user_id:user.id,
   admin_password:password,
   notify
})
})

if(!data.status){
showSnackbar(data.message || "Failed to close customer profile","error");
setLoading(false);
return;
}

showSnackbar(data.message || "Customer profile closed successfully","success");

setTimeout(()=>{
navigate("/admin/users");
},2000);

}catch(err){
console.log(err);
showSnackbar("Server error. Try again.","error");
}

setLoading(false);
};


return(

<Box sx={{ ...adminPageSx }}>

<Card sx={{ p:{ xs:2, sm:4 }, maxWidth:600, mx:"auto" }}>

<Typography variant="h5" sx={{mb:2, color:"#d32f2f"}}>
Close Customer Profile
</Typography>

<Typography sx={{mb:2}}>
User: <b>{user?.email}</b>
</Typography>

<Typography sx={{mb:2, color:"#d32f2f", fontWeight:600}}>
This action closes access and removes customer-identifying profile and bank details.
</Typography>

<Typography sx={{mb:2}}>
This will:
</Typography>

<ul>
<li>Block login, password reset, wallet use, payments, and ticket purchases</li>
<li>Preserve payments, wallet ledger, tickets, winnings, commissions, and audit history</li>
</ul>

<Typography sx={{mb:2}}>
No financial or lottery history will be deleted.
</Typography>

<FormControlLabel
control={
<Checkbox
checked={notify}
onChange={(e)=>setNotify(e.target.checked)}
/>
}
label={`Notify user (${user?.email})`}
/>

<FormControlLabel
control={
<Checkbox
checked={confirmed}
onChange={(e)=>setConfirmed(e.target.checked)}
/>
}
label="I understand this closes access and anonymizes profile data without deleting financial or lottery history"
/>

<TextField
label="Admin Password"
type={showPassword ? "text" : "password"}
fullWidth
sx={{mt:2}}
value={password}
onChange={(e)=>setPassword(e.target.value)}
InputProps={{
endAdornment: (
<InputAdornment position="end">
<IconButton onClick={()=>setShowPassword((prev)=>!prev)} edge="end">
{showPassword ? <VisibilityOffIcon /> : <RemoveRedEyeIcon />}
</IconButton>
</InputAdornment>
)
}}
/>

<Button
fullWidth
variant="contained"
sx={{mt:3, bgcolor:"#d32f2f"}}
onClick={handleDelete}
disabled={loading || !confirmed}
>

{loading ? (
<CircularProgress size={22} sx={{color:"#fff"}}/>
) : (
"Confirm Profile Closure"
)}

</Button>

</Card>




<Snackbar
open={snackbar.open}
autoHideDuration={4000}
onClose={handleCloseSnackbar}
anchorOrigin={{vertical:"top",horizontal:"center"}}
>
<Alert severity={snackbar.severity} onClose={handleCloseSnackbar}>
{snackbar.message}
</Alert>
</Snackbar>

</Box>

);

}
